<template>
<div>
  <q-btn style="position: absolute;bottom: 20px"
         :style="$route.params.position === 'left' ? 'left: 20px' : 'right: 20px'"
         fab
         flat>
    <q-menu :anchor="$route.params.position === 'left' ? 'bottom left' : 'bottom right'"
            :self="$route.params.position === 'left' ? 'top left' : 'top right'"
            @before-hide="fab = false"
            persistent
            :offset="[0, 10]"
            max-height="100%"
            max-width="100%"
            content-class="form-menu"
            v-model="menu">
      <router-view @closeMenu="menu = false" />
    </q-menu>
  </q-btn>
  <q-fab style="position: absolute;bottom: 20px"
         :style="$route.params.position === 'left' ? 'left: 20px' : 'right: 20px'"
         fab
         ref="fab"
         v-model="fab"
         @click="menu = !menu"
         :color="!fab ? 'eng' : 'red-14'"
         icon="img:https://engagesms.net/app/images/btnicon.png" />
</div>
</template>

<script>
export default {
  name: 'Widget',

  created() {
    if (this.$route.params.color) {
      let style = document.createElement('style')
      style.innerHTML = '.text-eng { color: #' + this.$route.params.color + '; }'
      style.innerHTML = '.bg-eng { background: #' + this.$route.params.color + '; }'
      document.getElementsByTagName('head')[0].appendChild(style)
    }
  },

  data() {
    return {
      menu: false,
      fab: false
    }
  }
}
</script>

<style>
</style>
